module.exports = __webpack_public_path__ + "static/media/Double Matting Text.863ec5dc.png";